import React from 'react';
import { motion } from 'framer-motion';
import { CreditCardIcon, LockIcon, ShieldCheckIcon, TelescopeIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage } from '../data/offer';
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage-deep starfield relative isolate overflow-hidden pb-16 pt-12 sm:pb-20 sm:pt-16" data-id="element-123" data-mp="1297f6cerrfdj">
      {/* Órbita sutil como marca de agua */}
      <svg className="pointer-events-none absolute -right-24 -top-24 -z-10 h-[420px] w-[420px] text-gold/20" viewBox="0 0 200 200" fill="none" aria-hidden="true" data-id="element-124" data-mp="x8b8xs6y3h4y">
        <circle cx="100" cy="100" r="96" stroke="currentColor" strokeWidth="0.6" data-id="element-125" data-mp="neaugzprwzjk" />
        <ellipse cx="100" cy="100" rx="96" ry="38" stroke="currentColor" strokeWidth="0.6" data-id="element-126" data-mp="3d33d6tuq0lin" />
        <ellipse cx="100" cy="100" rx="38" ry="96" stroke="currentColor" strokeWidth="0.6" data-id="element-127" data-mp="380vyhwiiarcm" />
        <circle cx="196" cy="100" r="3" fill="currentColor" data-id="element-128" data-mp="3j9u0yz9q1olt" />
      </svg>

      <div className="mx-auto max-w-6xl px-4 text-center" data-id="element-129" data-mp="3o7vkflb27pxt">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-deep px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-gold" data-id="element-130" data-mp="3o59e1ozwngh6">
          <TelescopeIcon className="h-4 w-4" data-id="element-131" data-mp="358ztqjyettoq" /> Megapack Astronomía Listo™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.06] text-white sm:text-6xl md:text-7xl" data-id="element-132" data-mp="2qkmsp8kgtknd">
          Del diagnóstico a la acción.<br data-id="element-133" data-mp="2lmuyu909fogj" />
          <span className="text-gold" data-id="element-134" data-mp="s21gc6a6u3xc">Todo resuelto.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto my-4 max-w-2xl sm:my-6" data-id="element-135" data-mp="s44ghj521dfs">
          <img src={productImage} alt="Megapack Astronomía Listo: nueve tomos y cinco bonos para docentes de Astronomía en Argentina" className="mx-auto w-full drop-shadow-[0_24px_40px_rgba(2,6,20,.6)]" data-id="element-136" data-mp="de6oes4083lb" />
        </motion.div>

        <div className="flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-137" data-mp="112g6biy3k776">
          {['Acceso inmediato', 'Hecho para Argentina', 'Pago seguro'].map(item => <span key={item} className="rounded-full border border-lineDark bg-deep px-3 py-2" data-id="element-138" data-mp="x3h1dycd8afq">
              {item}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-139" data-mp="3hqk747aj58o3">
          <Button onClick={scrollToPricing} arrow data-id="element-140" data-mp="3htpzpwidasok">QUIERO MI MEGAPACK AHORA</Button>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-141" data-mp="1x7871tlc81wr">
          <span className="inline-flex items-center gap-1.5" data-id="element-142" data-mp="269zkfyxrx7r1"><ShieldCheckIcon className="h-4 w-4 text-gold" data-id="element-143" data-mp="2697o2lwcr5zp" /> Garantía 7 días</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-144" data-mp="2b0zi56epvtul"><LockIcon className="h-4 w-4 text-gold" data-id="element-145" data-mp="2b2k9kn5qiwo8" /> Pago seguro</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-146" data-mp="2fzanp4xzbi70"><CreditCardIcon className="h-4 w-4 text-gold" data-id="element-147" data-mp="2kyn9rnh10l8j" /> Mercado Pago</span>
        </div>

        <p className="mt-5 inline-flex items-center gap-2 text-xs font-semibold text-mutedDark" data-id="element-148" data-mp="2p0h65jk6v32w">
          <ZapIcon className="h-4 w-4 text-gold" data-id="element-149" data-mp="2tzlek7zagws6" /> Para docentes de Astronomía y áreas relacionadas de toda Argentina
        </p>
      </div>
    </section>;
}